<template>
  <v-dialog v-model="dialog" persistent>
    <v-card>
      <v-card-title>Edit Tooltip</v-card-title>
      <v-card-text>
        <v-text-field v-model="description" label="Beschreibung" />
        <MathField v-model="formula" />
        <v-textarea v-model="legend" label="Legende" />
      </v-card-text>
      <v-card-actions>
        <v-btn @click="dialog = false">Cancel</v-btn>
        <v-btn @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import MathField from '../Elements/MathField.vue';
import { useMainStore } from '@/stores/mainStore';
import axios from 'axios';

const mainStore = useMainStore();

const props = defineProps({
  name: {
    type: String,
    required: true,
  }
})

const dialog = defineModel()

const description = ref('');
const legend = ref('');
const formula = ref('');

onMounted(() => {
  if (mainStore.tooltips[props.name]){
    description.value = mainStore.tooltips[props.name].description;
    legend.value = mainStore.tooltips[props.name].legend;
    formula.value = mainStore.tooltips[props.name].formula;
  }
})

function save() {
  axios.post(`/api/tooltips`, {
    id: props.name,
    description: description.value,
    legend: legend.value,
    formula: formula.value,
  }).then(() => {
    mainStore.tooltips[props.name] = {
      description: description.value,
      legend: legend.value,
      formula: formula.value,
    };
    dialog.value = false;
  });
}

</script>
